module.exports = {
    TPP_KEYS_STATUS_ACTIVE: 'active',
    TPP_KEYS_STATUS_DELETED: 'deleted',
    TPP_KEY_TYPE_AISP: 'PSP_AI',
    TPP_KEY_TYPE_ASP: 'PSP_AS',
    TPP_KEY_TYPE_PISP: 'PSP_PI',
    TPP_KEY_TYPE_FCS: 'PSP_IC',
    TPP_KEY_HAS_READABLE_CONSENT: 'hasReadableConsent',
    TPP_KEY_HAS_FUNDS_CONSENT: 'hasFundsConsent',
    CONSENT_STATUS_VALID: 'valid',
    CONSENT_STATUS_VALIDATED: 'validated',
    CONSENT_STATUS_RECEIVED: 'received',
    CONSENT_STATUS_REJECTED: 'rejected',
    CONSENT_STATUS_EXPIRED: 'expired',
    CONSENT_STATUS_REVOKEDBYPSU: 'revoked_by_psu',
    CONSENT_STATUS_TERMINATEDBYTPP: 'terminated_by_tpp'
};

// aqui sonp     las mierdas que hay que cambiar
